import { __awaiter, __decorate } from "tslib";
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DomSanitizer } from "@angular/platform-browser";
import { WebsiteThemeService } from "../../../services/website-theme.service";
import { SharedHttp } from "../../../services/http-client.service";
import { WebClientService } from "../../../services/webclient-settings.service";
let GeneralPersonalDataComponent = class GeneralPersonalDataComponent {
    constructor(sanitizer, themeService, httpClient, webSettingsService) {
        this.sanitizer = sanitizer;
        this.themeService = themeService;
        this.httpClient = httpClient;
        this.webSettingsService = webSettingsService;
        this.borderRadiusSmaller = '';
        this.borderRadiusLarger = '';
        this.inputBackColor = '';
        this.errorColor = '';
        this.linkColor = '';
        this.accentColor = '';
        this.mainColor = '';
        this.textColor = '';
        this.firstNameError = false;
        this.lastNameError = false;
        this.dayFormatError = false;
        this.monthFormatError = false;
        this.yearFormatError = false;
        this.birthdayFormatError = false;
        this.birthdayError = false;
        this.residentError = false;
        this.showPepDesc = false;
        this.pepError = false;
        this.agreeTerms = 0;
        this.agreeTermsError = false;
        this.agreeBusinessTermsError = false;
        this.generalPersonalData = {
            firstName: undefined,
            lastName: undefined,
            day: undefined,
            month: undefined,
            year: undefined,
            birthday: undefined,
            resident: undefined,
            ispep: undefined,
            agreeBusinessTerms: 0,
            newsletter: 1,
            sms_notifications: 1
        };
        this.generalDataVerified = new EventEmitter();
        this.themeService.getTheme().subscribe((data) => {
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
            this.inputBackColor = this.themeService.getStyleAttribute('input_background_color');
            this.errorColor = this.themeService.getStyleAttribute('error_color');
            this.linkColor = this.themeService.getStyleAttribute('link_color');
            this.accentColor = this.themeService.getStyleAttribute('accent_color');
            this.mainColor = this.themeService.getStyleAttribute('main_color');
            this.textColor = this.themeService.getStyleAttribute('text_color');
        });
    }
    ngOnInit() {
        if (!this.showNONEUAttribute) {
            this.generalPersonalData.resident = 0;
            this.generalPersonalData.ispep = 0;
        }
    }
    checkFirstName() {
        this.firstNameError = this.generalPersonalData.firstName === undefined || this.generalPersonalData.firstName === null || this.generalPersonalData.firstName === '';
        return !this.firstNameError;
    }
    checkLastName() {
        this.lastNameError = this.generalPersonalData.lastName === undefined || this.generalPersonalData.lastName === null || this.generalPersonalData.lastName === '';
        return !this.lastNameError;
    }
    checkDay() {
        var _a;
        const day = (_a = this.generalPersonalData.day) === null || _a === void 0 ? void 0 : _a.toString();
        if (!day || (day.length > 2 || day.length === 2 && (day < 1 || day > 31))) {
            this.dayFormatError = true;
            this.birthdayFormatError = true;
            return false;
        }
        this.dayFormatError = false;
        this.birthdayFormatError = this.dayFormatError || this.monthFormatError || this.yearFormatError;
        this.generalPersonalData.birthday = this.generalPersonalData.day + '.' + this.generalPersonalData.month + '.' + this.generalPersonalData.year;
        return true;
    }
    checkMonth() {
        var _a;
        const month = (_a = this.generalPersonalData.month) === null || _a === void 0 ? void 0 : _a.toString();
        if (!month || (month.length > 2 || month.length === 2 && (month < 1 || month > 12))) {
            this.monthFormatError = true;
            this.birthdayFormatError = true;
            return false;
        }
        this.monthFormatError = false;
        this.birthdayFormatError = this.dayFormatError || this.monthFormatError || this.yearFormatError;
        this.generalPersonalData.birthday = this.generalPersonalData.day + '.' + this.generalPersonalData.month + '.' + this.generalPersonalData.year;
        return true;
    }
    checkYear() {
        var _a;
        const year = (_a = this.generalPersonalData.year) === null || _a === void 0 ? void 0 : _a.toString();
        if (!year || (year.length !== 4 || year.length === 4 && (year < 1 || year > 2100))) {
            this.yearFormatError = true;
            this.birthdayFormatError = true;
            return false;
        }
        this.yearFormatError = false;
        this.birthdayFormatError = this.dayFormatError || this.monthFormatError || this.yearFormatError;
        this.generalPersonalData.birthday = this.generalPersonalData.day + '.' + this.generalPersonalData.month + '.' + this.generalPersonalData.year;
        this.birthdayError = false;
        return true;
    }
    checkBirthDate() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.checkDay() && this.checkMonth() && this.checkYear()) {
                this.birthdayError = false;
                const result = yield this.httpClient.post('user/checkage', { date: this.generalPersonalData.birthday }).toPromise();
                const data = result;
                if (data.Message === 'ERROR') {
                    this.birthdayError = true;
                    return false;
                }
                if (data.Message === 'BAD_FORMAT') {
                    this.birthdayFormatError = true;
                    return false;
                }
                if (data.Message === 'OK') {
                    return true;
                }
            }
            return false;
        });
    }
    onResidentSelectionChange(entry) {
        this.generalPersonalData.resident = entry;
        this.residentError = false;
    }
    onPepSelectionChange(entry) {
        this.generalPersonalData.ispep = entry;
        this.showPepDesc = entry === 1;
        this.pepError = false;
    }
    checkResident() {
        if (this.generalPersonalData.resident === undefined || this.generalPersonalData.resident == null) {
            this.residentError = true;
            return false;
        }
        return true;
    }
    checkPep() {
        if (this.generalPersonalData.ispep === undefined || this.generalPersonalData.ispep == null) {
            this.pepError = true;
            return false;
        }
        return true;
    }
    checkAgreeTerms() {
        this.agreeTermsError = this.agreeTerms == 0;
        return !this.agreeTermsError;
    }
    checkAgreeBusinessTerms() {
        this.agreeBusinessTermsError = this.generalPersonalData.agreeBusinessTerms == 0;
        return !this.agreeBusinessTermsError;
    }
    checkIfFormIsValid() {
        return Object.values(this.generalPersonalData).some(field => field === undefined || field === null || field === '') ||
            this.firstNameError || this.lastNameError || this.birthdayFormatError || this.birthdayError || this.dayFormatError ||
            this.monthFormatError || this.yearFormatError || this.agreeTerms == 0 || this.generalPersonalData.agreeBusinessTerms == 0;
    }
    updateGeneralUserData() {
        return __awaiter(this, void 0, void 0, function* () {
            const birthDayValid = yield this.checkBirthDate();
            if (this.checkFirstName() && this.checkLastName() && birthDayValid &&
                this.checkResident() && this.checkPep() && this.checkAgreeTerms() && this.checkAgreeBusinessTerms()) {
                this.httpClient.post('user/updategeneraluserinfo', this.generalPersonalData).subscribe((data) => {
                    this.generalDataVerified.emit(true);
                });
            }
        });
    }
};
GeneralPersonalDataComponent.ctorParameters = () => [
    { type: DomSanitizer },
    { type: WebsiteThemeService },
    { type: SharedHttp },
    { type: WebClientService }
];
__decorate([
    Input()
], GeneralPersonalDataComponent.prototype, "showNONEUAttribute", void 0);
__decorate([
    Output()
], GeneralPersonalDataComponent.prototype, "generalDataVerified", void 0);
GeneralPersonalDataComponent = __decorate([
    Component({
        selector: 'ecd-general-personal-data',
        template: __importDefault(require("./general-personal-data.component.html")).default,
    })
], GeneralPersonalDataComponent);
export { GeneralPersonalDataComponent };
